import React from "react";
import { Select, Button, Modal, Input } from "antd";
import FormWrapper from "../../../components/FormWrapper/FormWrapper";
import styles from "./IncreaseCreditModal.module.css";
import {
  addPriceComma,
  checkValidEngNumbers,
  onChangeProvince,
} from "../../../core/utils";
import CloseModalButton from "../../../components/CloseModalButton/CloseModalButton";

export const IncreaseCreditModal = (props) => {
  const {
    isModalOpen,
    setIsModalOpen,
    users,
    onChangeAmount,
    increaseCredit,
    increaseCreditState,
    handleChangeIncreaseCreditState,
    cities,
    setCities,
    provinces,
    getUsers,
  } = props;
  const { Option } = Select;

  return (
    <>
      <div className="w-100 ">
        <Button
          className="button-primary w-220px  flex flex-items-center flex-content-center"
          onClick={() => setIsModalOpen(true)}
        >
          <i className="far fa-plus pr-2 pb-2" />
          <span>Increase Credit</span>
        </Button>
      </div>
      <Modal
        className={styles.CreditReportModalContainer}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          handleChangeIncreaseCreditState({
            province_id: null,
            city_id: null,
            user_id: null,
            amount: "",
          });
        }}
        footer={null}
        closable={true}
        bodyStyle={{
          paddingTop: 40,
        }}
        closeIcon={
          <CloseModalButton isCloseIcon close={() => setIsModalOpen(false)} />
        }
      >
        <FormWrapper>
          <Select
            className="border-black-8"
            onChange={(value) => {
              onChangeProvince(
                value,
                () =>
                  handleChangeIncreaseCreditState({
                    province_id: value,
                    city_id: null,
                    user_id: null,
                  }),
                setCities
              );
              getUsers(value, undefined);
            }}
            value={increaseCreditState.province_id}
          >
            <Option value={null} name="All Provinces">
              All Provinces
            </Option>
            {provinces.map((province) => {
              return (
                <Option value={province.id} name={province.name}>
                  {province.name}
                </Option>
              );
            })}
          </Select>
          <Select
            className="border-black-8"
            onChange={(value) => {
              handleChangeIncreaseCreditState({
                city_id: value,
                user_id: null,
              });
              getUsers(increaseCreditState.province_id, value);
            }}
            value={increaseCreditState.city_id}
          >
            <Option value={null} name="All Cities">
              All Cities
            </Option>
            {cities.map((city) => {
              return (
                <Option value={city.id} name={city.name}>
                  {city.name}
                </Option>
              );
            })}
          </Select>
          <Select
            className="border-black-8  "
            placeholder="Employee"
            onChange={(value) =>
              handleChangeIncreaseCreditState({ user_id: value })
            }
            value={increaseCreditState.user_id}
          >
            {users &&
              users?.map((item) => {
                return (
                  <Option value={item.pk} name={item.pk}>
                    {item?.user?.fullname}
                  </Option>
                );
              })}
          </Select>

          <Input
            className=" border-black-8 "
            type="text"
            value={addPriceComma(increaseCreditState.amount)}
            placeholder="Credit"
            onChange={(e) => onChangeAmount(e.target.value)}
            onKeyDown={checkValidEngNumbers}
          />
          <div></div>
          <Button className="button-secondary " onClick={increaseCredit}>
            Add Credit
          </Button>
        </FormWrapper>
      </Modal>
    </>
  );
};
